import { Comment, PaginatedResponse } from '@arpeggi/shared'
import axios from 'axios'
import { GetCommentsParams } from '../types'

export const getComments = async (discussionId: number, params: GetCommentsParams) => {
  const { data } = await axios.get<PaginatedResponse<Comment>>(
    `/api/v2/discussions/${discussionId}/comments`,
    { params }
  )

  return data
}
